module.exports = __webpack_public_path__ + "img/DABEST.43a09767.svg";